import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const Integrations = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.994 145c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5c-28.167 0-51 1.567-51 3.5s22.833 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M109.985 125c-10.74 9.343-24.776 15-40.135 15-15.226 0-29.152-5.56-39.856-14.758V125h79.991Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        d="M109.985 125c-10.74 9.343-24.776 15-40.135 15-15.226 0-29.152-5.56-39.856-14.758V125h79.991Z"
      />
      <path
        fill="#D9D9D9"
        d="M81.788 138.836A61.46 61.46 0 0 1 69.85 140c-1.485 0-2.957-.053-4.416-.157a9.899 9.899 0 0 0 .997-4.343c0-5.488-4.449-9.938-9.937-9.938-5.46 0-9.89 4.402-9.938 9.849a61.007 61.007 0 0 1-10.77-5.761c1.957-1.517 2.624-4.36 1.224-6.657-2.769-4.545 2.432-9.746 6.976-6.977 2.936 1.789 6.764.204 7.575-3.137 1.256-5.172 8.61-5.172 9.866 0 .811 3.341 4.638 4.926 7.574 3.137 4.545-2.769 9.746 2.432 6.977 6.977-1.789 2.935-.203 6.763 3.137 7.574 4.028.977 4.919 5.655 2.673 8.269Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M81.788 138.836A61.46 61.46 0 0 1 69.85 140c-1.485 0-2.957-.053-4.416-.157a9.899 9.899 0 0 0 .997-4.343c0-5.488-4.449-9.938-9.937-9.938-5.46 0-9.89 4.402-9.938 9.849a61.007 61.007 0 0 1-10.77-5.761c1.957-1.517 2.624-4.36 1.224-6.657-2.769-4.545 2.432-9.746 6.976-6.977 2.936 1.789 6.764.204 7.575-3.137 1.256-5.172 8.61-5.172 9.866 0 .811 3.341 4.638 4.926 7.574 3.137 4.545-2.769 9.746 2.432 6.977 6.977-1.789 2.935-.203 6.763 3.137 7.574 4.028.977 4.919 5.655 2.673 8.269Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.817 124.854c.279-.248.556-.497.83-.748a.5.5 0 1 0-.676-.737c-.54.495-1.089.981-1.646 1.457a.496.496 0 0 0-.186.343.496.496 0 0 0 .467.547.506.506 0 0 0 .368-.13c.283-.241.564-.485.843-.732Zm3.274-4.556a.507.507 0 0 0-.106.555.493.493 0 0 0 .283.268.49.49 0 0 0 .39-.017.5.5 0 0 0 .159-.119 61.766 61.766 0 0 0 4.316-5.089.501.501 0 0 0-.797-.605 60.844 60.844 0 0 1-4.245 5.007Zm-9.417 9.343a.504.504 0 0 0 .209-.32.474.474 0 0 0-.002-.195.487.487 0 0 0-.215-.317.498.498 0 0 0-.377-.07.49.49 0 0 0-.179.076 60.716 60.716 0 0 1-3.7 2.336.499.499 0 0 0 .123.916.5.5 0 0 0 .38-.051 61.929 61.929 0 0 0 3.761-2.375Zm-5.706 3.46a.5.5 0 0 0-.472-.882c-18.15 9.695-39.99 9.416-57.774-.37a.49.49 0 0 0-.38-.042.494.494 0 0 0-.359.424.5.5 0 0 0 .256.494c18.08 9.947 40.278 10.232 58.729.376Zm24.138-25.146a.494.494 0 0 0-.043.38.497.497 0 0 0 .62.342.494.494 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.5.5 0 0 0-.883.47c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.501.501 0 0 0 .865-.503 60.76 60.76 0 0 0-2.374-3.762.5.5 0 0 0-.826.564 60.066 60.066 0 0 1 2.335 3.7v.001Zm-89.69 79.612a.492.492 0 0 0 .7-.097.49.49 0 0 0 .098-.37.501.501 0 0 0-.193-.33 60.521 60.521 0 0 1-5.007-4.244.498.498 0 0 0-.686.04.5.5 0 0 0-.001.687 61.529 61.529 0 0 0 5.09 4.314Zm-8.211-7.484a.5.5 0 1 0 .737-.676 61.999 61.999 0 0 1-.7-.776C2.462 93.874 4.83 55.586 29.907 33.401c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.502.502 0 0 0 .044-.718 61.894 61.894 0 0 0-.655-.755l-.006-.008-.036-.04-.035-.04a62.576 62.576 0 0 0-3.805-3.926.48.48 0 0 0-.065-.073 61.224 61.224 0 0 0-5.09-4.314.495.495 0 0 0-.128-.071 61.195 61.195 0 0 0-7.187-4.653.496.496 0 0 0-.146-.12c-18.08-9.949-40.278-10.234-58.728-.377a.498.498 0 0 0-.22.237 57.12 57.12 0 0 0-1.407.785.498.498 0 0 0-.318.063 61.549 61.549 0 0 0-3.762 2.375.5.5 0 0 0-.195.262 62.219 62.219 0 0 0-4.8 3.673.498.498 0 0 0-.305.12c-.566.483-1.123.977-1.672 1.48a.5.5 0 0 0-.156.288 62.467 62.467 0 0 0-2.724 2.682.499.499 0 0 0-.29.151 61.682 61.682 0 0 0-4.316 5.089.498.498 0 0 0-.102.308 61.228 61.228 0 0 0-4.513 6.935.499.499 0 0 0-.234.215c-9.97 18.084-10.275 40.282-.434 58.727.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.047.03.093.055.136a61.3 61.3 0 0 0 2.373 3.763.496.496 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.043.048c.22.25.443.497.669.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.994 21h78v76h-78V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.994 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM82.994 30h-36a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 39h-36a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 48h-36a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 57h-36a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 66h-36a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 75h-36a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Z"
      />
      <path
        fill={primary}
        d="M83.089 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M74.225 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M39.27 30H26.9a.905.905 0 0 0 0 1.81H39.27a.905.905 0 0 0 0-1.81ZM33.953 33.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81ZM39.27 48H26.9a.905.905 0 0 0 0 1.81H39.27a.905.905 0 0 0 0-1.81ZM33.953 51.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81ZM39.27 66H26.9a.905.905 0 0 0 0 1.81H39.27a.905.905 0 0 0 0-1.81ZM33.953 69.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 113.214c7.403 0 13.404-5.997 13.404-13.394s-6.002-13.393-13.404-13.393c-7.403 0-13.404 5.996-13.404 13.393s6.001 13.394 13.404 13.394Zm1.675-18.416a1.675 1.675 0 0 0-3.35 0v3.348h-3.353a1.675 1.675 0 1 0 0 3.348h3.351v3.349a1.676 1.676 0 0 0 3.351 0v-3.349h3.351a1.674 1.674 0 1 0 0-3.348h-3.35v-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M120.244 23.5c0 12.012-9.738 21.75-21.75 21.75-12.013 0-21.75-9.738-21.75-21.75S86.48 1.75 98.494 1.75c12.012 0 21.75 9.738 21.75 21.75Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M120.244 23.5c0 12.012-9.738 21.75-21.75 21.75-12.013 0-21.75-9.738-21.75-21.75S86.48 1.75 98.494 1.75c12.012 0 21.75 9.738 21.75 21.75Z"
      />
      <path
        stroke={primary}
        d="M120.244 23.5c0 12.012-9.738 21.75-21.75 21.75-12.013 0-21.75-9.738-21.75-21.75S86.48 1.75 98.494 1.75c12.012 0 21.75 9.738 21.75 21.75Z"
      />
      <path
        fill="#fff"
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m128.494 75-2.5 2.5 2.5 2.5m4-5 2.5 2.5-2.5 2.5"
      />
      <path
        fill={primary}
        fillRule="evenodd"
        d="M92.327 13.667a2.667 2.667 0 0 0-2.667 2.666v13.334a2.667 2.667 0 0 0 2.667 2.666h13.333a2.666 2.666 0 0 0 2.667-2.666V16.333a2.666 2.666 0 0 0-2.667-2.666H92.327ZM102.994 19h-8v8h8v-8Z"
        clipRule="evenodd"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M94.994 11v2.667m8-2.667v2.667m-8 18.666V35m8-2.667V35M89.66 19h-2.666m2.666 8h-2.666m24-8h-2.667m2.667 8h-2.667m-16 5.333h13.333a2.666 2.666 0 0 0 2.667-2.666V16.333a2.666 2.666 0 0 0-2.667-2.666H92.327a2.667 2.667 0 0 0-2.667 2.666v13.334a2.667 2.667 0 0 0 2.667 2.666ZM94.994 19h8v8h-8v-8Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.427"
          y2="113.214"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default Integrations;
